import GroupDetails from "./GroupDetails";

export default GroupDetails